import Player from '@vimeo/player';

import { $, $$ } from '../lib/selectors';

function initVideo(videoEl) {
  const playEl = $(videoEl, '.js-video__play');
  const watcherEls = [...$$('.js-video-watcher'), videoEl];

  function updateWatchers(fn, clazz) {
    watcherEls.forEach(watcherEl => watcherEl.classList[fn](clazz));
  }

  const player = new Player(videoEl, {
    title: false,
    byline: false
  });

  player.on('loaded', () => {
    playEl.classList.remove('hidden');
  });

  player.on('playing', () => {
    updateWatchers('add', 'is-playing')
    updateWatchers('remove', 'is-loading');
  });

  player.on('pause', () => updateWatchers('remove', 'is-playing'));

  playEl.addEventListener('click', () => {
    updateWatchers('add', 'is-loading');
    player.play();
  });
}

export default function init() {
  const videoEl = $('.js-video');
  if (videoEl) {
    initVideo(videoEl);
  }
}
